import React from 'react';

import SelectInput from './SelectInput';
import { CostCenterItem } from './Types'


const valueGetter = <ProjectType,>(costCenterItem: CostCenterItem<ProjectType>) => costCenterItem.cost_center_item_id 
const nameGetter = <ProjectType,>(costCenterItem: CostCenterItem<ProjectType>) => costCenterItem.CostCenterItemName

function CostCenterItemSelect<ProjectType>({costCenterItems, value, onChange, required, ...props}: {
  costCenterItems: CostCenterItem<ProjectType>[],
  value: string | null,
  onChange: (newValue: string) => void,
  required: boolean,
  label?: string,
  disabled?: boolean
}) {
  return (
    <SelectInput
      options={costCenterItems}
      valueGetter={valueGetter}
      nameGetter={nameGetter}
      value={value}
      onChange={onChange}
      required={required}
      {...props}
    />
   )

}


export function asValidCostCenterItemId({costCenterItems, costCenterItemId}: {costCenterItems: CostCenterItem[], costCenterItemId: string | null}): string | null {
  return isValidCostCenterItem({costCenterItems, costCenterItemId}) ? costCenterItemId : null
}

export function isValidCostCenterItem({costCenterItems, costCenterItemId}: {costCenterItems: CostCenterItem[], costCenterItemId: string | null}) {
  return costCenterItems.find(item => item.cost_center_item_id === costCenterItemId) !== undefined
}


// function CostCenterItemSelectRaw({costCenterItems, onChange, value, ...props}) {
//   const isValid = isValidCostCenterItem({costCenterItems: costCenterItems, costCenterItemId: value})
//   const theValue = isValid ? value : ''
//   return (
//     <Select {...props} value={theValue} autoWidth={true} onChange={(e) => {onChange(e.target.value)}}>
//       <MenuItem value=""></MenuItem>
//       {costCenterItems.map(item => <MenuItem key={item.cost_center_item_id} value={item.cost_center_item_id}>{item.CostCenterItemName}</MenuItem>)}
//     </Select>
//   )
// }

// function CostCenterItemSelect({costCenterItems, ...props}) {
//   const localIsValidCostCenterItem = (costCenterItemId => isValidCostCenterItem({costCenterItems: costCenterItems, costCenterItemId: costCenterItemId}))
//   return FormWrapper({Component: CostCenterItemSelectRaw, validationFunction: localIsValidCostCenterItem})({costCenterItems: costCenterItems, ...props})
// }

export default CostCenterItemSelect
